<p-dropdown
  [filter]="true"
  [options]="datamodelOptions"
  [(ngModel)]="selectedDatamodelOption"
  (onChange)="onDatamodelChanged($event)"
  [style]="{'width': '100%'}"
  appendTo="body"
  placeholder="---"
></p-dropdown>
